<template>
  <div class="home container">
    <div class="row mt-5">
      <div class="col">
        <b-form-select v-model="stateSelected" :options="stateOptions"></b-form-select>
      </div>
      <div class="col">
        <b-form-select v-model="quarterSelected" :options="quarterOptions"></b-form-select>
      </div>
    </div>

    <b-alert show class="flex mt-4">
      <b-icon
        icon="exclamation-circle"
        class="info-circle-fill info mr-3 relative"
        style="top: .25em;"
      ></b-icon>
      <div>{{ generalQuoteInfoMessage }}</div>
    </b-alert>
  </div>
</template>

<script>
import States from '../constants/states';

export default {
  name: 'QuickStart',
  components: {},

  data() {
    return {
      states: States,
      stateSelected: null,
      quarterSelected: null,
      quarterOptions: [
        { value: null, text: 'Choose a quarter' },
        { value: 'Q1-2021', text: 'Q1: Jan - March 2021' },
      ],
      generalQuoteInfoMessage:
        'These values represent common or average values for your region so we can give you a rough estimate of what your premium might be. You can edit the values to get a more accurate quote, or call us and we can guide you through and get you taken care of!',
    };
  },

  computed: {
    stateOptions() {
      return [
        { value: null, text: 'Please select your state' },
        ...Object.keys(this.states).map((key) => ({ value: key, text: this.states[key] })),
      ];
    },
  },
};
</script>
